var _path, _path2, _path3, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgItLayoutShape5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 76,
    viewBox: "0 0 77 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2394_81336",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 77,
    height: 76
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.425781 0.337891H76.4354V75.6113H0.425781V0.337891Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2394_81336)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2394_81336",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -18,
    y: -67,
    width: 154,
    height: 241
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M135.844 157.888L13.2883 173.566L-17.3711 -51.0662L105.185 -66.7441L135.844 157.888Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2394_81336)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_2394_81336",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -18,
    y: -67,
    width: 154,
    height: 241
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M135.844 157.888L13.2883 173.566L-17.3711 -51.0662L105.185 -66.7441L135.844 157.888Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_2394_81336)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.694479 79.4203C0.719527 79.4566 0.7571 79.487 0.800935 79.5052C0.807197 79.5112 0.819722 79.5173 0.832246 79.5173L37.7224 92.9156C37.7349 92.9217 37.7475 92.9278 37.7662 92.9278C37.7725 92.9338 37.785 92.9338 37.7913 92.9338C37.8539 92.9399 37.9165 92.9278 37.9729 92.8914L37.9792 92.8853L69.7156 70.7447C69.7406 70.7265 69.7657 70.7022 69.7845 70.6719C69.7907 70.6659 69.7907 70.6659 69.7907 70.6598C69.797 70.6598 69.7907 70.6598 69.797 70.6598V70.6537C69.8033 70.6356 69.8158 70.6113 69.822 70.5931L77.393 43.0082C77.393 42.9961 77.3992 42.9779 77.3992 42.9658C77.4055 42.9355 77.3992 42.9052 77.393 42.8749L72.2893 22.2438L81.2128 1.02466V1.0186C81.2316 0.976161 81.2379 0.933722 81.2316 0.891285C81.2316 0.860973 81.2191 0.836721 81.2128 0.818534V0.812471C81.2066 0.800345 81.2003 0.78822 81.1941 0.776096C81.1628 0.733657 81.1252 0.703344 81.0751 0.679094C81.0626 0.673032 81.05 0.673031 81.0438 0.666969C80.9999 0.654843 80.9624 0.648782 80.9185 0.660906L33.4203 6.62045C33.4141 6.62045 33.4015 6.62651 33.4015 6.62651H33.3953C33.3765 6.63258 33.3514 6.63864 33.3327 6.65077C33.3013 6.66289 33.27 6.68714 33.2513 6.71139L11.2023 31.5438C11.1898 31.556 11.1773 31.5681 11.171 31.5802C11.146 31.6227 11.1334 31.6651 11.1334 31.7197L11.2211 44.8028L0.663168 79.1899C0.656905 79.202 0.656906 79.2081 0.656906 79.2202C0.644383 79.2687 0.650644 79.3233 0.66943 79.3657C0.675692 79.3839 0.681954 79.4021 0.694479 79.4203ZM38.0668 92.1699L36.2508 61.2688L68.9391 70.6295L38.0668 92.1699ZM54.4798 55.3456L68.6636 69.9929L36.8833 60.8929L54.4798 55.3456ZM36.3009 60.5171L37.9729 51.0473L53.5906 55.0607L36.3009 60.5171ZM54.2043 54.0361L40.9098 34.7328L51.5554 21.492L54.2043 54.0361ZM53.9288 54.5999L38.0668 50.5198L40.7282 35.4239L53.9288 54.5999ZM37.5283 50.3804L18.4163 45.4636L40.2085 35.1875L37.5283 50.3804ZM37.4343 50.9078L35.7624 60.3958L18.7169 46.0941L37.4343 50.9078ZM69.415 69.9929L55.0059 55.1031L76.6979 43.4751L69.415 69.9929ZM54.8055 54.5999L52.1002 21.4314L76.654 42.887L54.8055 54.5999ZM76.654 42.1595L52.5511 21.1101L71.7821 22.4742L76.654 42.1595ZM71.8197 21.9467L52.5636 20.5766L80.3487 1.66124L71.8197 21.9467ZM79.8853 1.32779L51.7809 20.4553L34.1405 7.06909L79.8853 1.32779ZM51.3864 20.8312L40.7032 34.1265L33.915 7.57228L51.3864 20.8312ZM33.3139 7.45103L40.2085 34.4175L11.96 31.5075L33.3139 7.45103ZM39.5885 34.8904L17.7775 45.1787L11.8473 32.0289L39.5885 34.8904ZM11.6908 33.011L17.1952 45.2211L11.7659 44.6027L11.6908 33.011ZM11.6908 45.1302L17.2202 45.7546L2.1786 76.1222L11.6908 45.1302ZM17.7275 45.9668L35.4743 60.8566L1.53987 78.6443L17.7275 45.9668ZM35.6997 61.3355L37.522 92.273L1.5837 79.2263L35.6997 61.3355Z",
    fill: "#38B6FF"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItLayoutShape5);
export default __webpack_public_path__ + "static/media/it-layout-shape-5.1cb7fdf94b2dc08e84edb5cf323ad876.svg";
export { ForwardRef as ReactComponent };